import { styled } from '@mui/material';
import React from 'react';

type TitleSize = 'sm' | 'md';
type Background = 'default' | 'white';
type Alignment = 'left' | 'center' | 'right';

const TableTitleCell = styled('th', {
  shouldForwardProp: (prop) =>
    prop !== 'background' && prop !== 'size' && prop !== 'showDivider',
})<{
  background?: Background;
  size?: TitleSize;
  align?: Alignment;
  showDivider?: boolean;
}>(({ theme, background, size, align, showDivider }) => ({
  padding: size === 'sm' ? theme.spacing(3, 5) : theme.spacing(5),
  borderBottom: `1px solid ${theme.palette.divider}`,
  borderLeft: showDivider ? `1px solid ${theme.palette.divider}` : 'none',
  fontSize: size === 'sm' ? theme.fontSizes?.sm : theme.fontSizes?.regular,
  textAlign: align,
  fontWeight: 'bold',
  color: theme.palette.text.primary,
  backgroundColor:
    background === 'white'
      ? theme.palette.common.white
      : theme.palette.background.header,
}));

export type TableTitleType = {
  label: string;
  size?: TitleSize;
  background?: Background;
  align?: Alignment;
  colspan?: number;
};

type Props = {
  titles: Array<TableTitleType>;
  fallbackBackground?: Background;
};

const TableTitle: React.FC<Props> = ({
  titles,
  fallbackBackground = 'default',
}) => {
  return (
    <>
      {titles.map((titleItem) => (
        <TableTitleCell
          key={titleItem.label}
          size={titleItem.size ?? 'md'}
          background={titleItem.background ?? fallbackBackground}
          colSpan={titleItem.colspan}
          align={titleItem.align ?? 'left'}
          showDivider={titles.length > 1}
        >
          {titleItem.label}
        </TableTitleCell>
      ))}
    </>
  );
};

export default TableTitle;
